import SelectDateTime from 'components/Forms/SelectDateTime';
import moment from 'moment';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

interface Props {
    name: string;
    syncWithField: string;
    timeDiffInMinutes?: number;
}

const DateTo = (props: Props) => {
    const { watch, setValue, getValues, trigger } = useFormContext();

    const [syncWithField] = watch([props.syncWithField]);

    const { name } = props;
    useEffect(() => {
        const endDate = getValues(name);
        if (!syncWithField) return;


        const endTime = props.timeDiffInMinutes
            ? moment(syncWithField).add(props.timeDiffInMinutes, 'minutes').toDate()
            : moment(syncWithField).add(1, 'hours').toDate();
        if (!endDate) {
            setValue(name, endTime);
            trigger(name);
        }
        else {
            const momentStart = moment(syncWithField);
            const momentEnd = moment(endDate)
            if (momentEnd.isBefore(momentStart)) {
                setValue(name, endTime);
                trigger(name);
            }
        }

    }, [syncWithField, getValues, setValue, trigger, name]);

    return (
        <SelectDateTime
            name={props.name}
            label='Slut dato og tid'
            className='w-full'
            format="datetime"
        />
    )
}

export default DateTo;